import { Component, OnInit, ViewContainerRef } from '@angular/core';
import {CarouselComponent} from "angular2-carousel";
import htmlDocx from 'html-docx-js/dist/html-docx';
import { LabeledProductService } from '../../../labeledproducts/services/labeledproduct.service';
import { SaleProductService } from '../../../sales/services/sale-product.service';
import { SaleService } from '../../../sales/services/sale.service';
import { SaleReturnProductService } from '../../../salesreturn/services/sale-return-product.service';
import { SaleReturnService } from '../../../salesreturn/services/sale-return.service';
import { PersonService } from '../../../person/services/person.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { InvoiceService } from '../../../common/services/invoice.service';
import { CounterService } from '../../../common/services/counter.service';
import { CounterSettings } from '../../../api.settings';

import * as _ from 'lodash/lodash';
import * as FileSaver from 'file-saver';
import * as moment from 'moment/moment';

import pdfMake from 'pdfmake/build/pdfmake';
import { PdfMakeWrapper,Img,Txt,Table,Cell} from 'pdfmake-wrapper';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


declare var JSZip: any;
declare var Docxtemplater: any;
declare var JSZipUtils: any;
declare var ImageModule: any;
declare var fs: any;
declare var Buffer: any;

@Component({
    selector: 'app-tpv-return',
    templateUrl: './tpv-return.component.html',
    styleUrls: ['./tpv-return.component.css'],
    providers:[LabeledProductService,SaleProductService,SaleService,PersonService,CounterService,InvoiceService,SaleReturnProductService,SaleReturnService]

  })

export class TPVReturnComponent implements OnInit {
    barcode: number;
    labeledProduct:any = {};
    saleProducts:any =[];//Array para añadir los productos de la compra
    totalSale:number = 0;
    enableGenerateInvoice:boolean = false;
    person:any = {};
    id: number = undefined;
    saleId: number = undefined;
    reason: string;
    private sub: any;
    sale:any = {
        number:undefined,
        date:new Date()
       
    };
    saleReturn: any ={};
    saleReturnAvailable:boolean = false;
    addDiscount:boolean = false;
    addDiscountReturn:boolean = false;
    addressTicket:string='';
    createdTicket:string='';
    shopSerie:string = '';
    method_of_payment:number = 1;

    constructor(private labeledProductService:LabeledProductService,private saleProductService:SaleProductService,private saleService:SaleService,private counterService:CounterService,
                private personService: PersonService,public toastr: ToastsManager,vcr: ViewContainerRef,private route: ActivatedRoute, private router: Router,
                private invoiceService:InvoiceService,public saleReturnService:SaleReturnService, public saleReturnProductService:SaleReturnProductService) {
                    this.toastr.setRootViewContainerRef(vcr);  
                }

    ngOnInit() {
    this.shopSerie = this.checkSerie(parseInt(localStorage.getItem('shop')));
    this.sub = this.route.params.subscribe(params => {
        this.route.queryParams.subscribe(queryParams => {
            if (params['id'] !== undefined){
                this.id = params['id'];
                this.getReturnSale();
            }else if (queryParams['saleId'] !== undefined){
                this.saleId = queryParams['saleId'];
                this.id = params['id'];
                this.getSale();
            }
          });
        });
    }

    checkSerie(shopId){
        if (shopId == 1){
            return 'M';
        }else if (shopId == 5){
            return 'T';
        }else if (shopId == 7){
            return 'O';
        }else if (shopId == 8){
            return 'C';
        }
    }

    getSale(){
        this.addDiscount=false;
        this.saleService.get(this.saleId).subscribe((sale) => { 
            let params ={
              sale_id: sale.id
            }
            this.sale = sale;
            this.method_of_payment = this.sale.method_of_payment == "Efectivo"? 1: this.sale.method_of_payment == "Tarjeta"? 2:this.sale.method_of_payment == "Bizum"? 3:this.sale.method_of_payment == "Transferencia"? 4:1;
            this.saleProductService.query(params).subscribe((saleProducts) =>{
                saleProducts.forEach((s)=>{
                    s.name = s.labeledproduct.name;
                    s.imei = (s.labeledproduct.imei1?s.labeledproduct.imei1:'') +" "+ (s.labeledproduct.imei2?s.labeledproduct.imei2:'');
                    s.serial_number=s.labeledproduct.serial_number;
                });
                this.saleProducts = saleProducts;
                saleProducts.forEach((s)=>{
                    this.checkDiscountForTicket(s);
                    if (s.salereturnproduct.length == 0){
                        this.saleReturnAvailable = true
                    }
                });
            });   
        });
    }

    getReturnSale(){
        this.addDiscountReturn=false;
        this.saleReturnService.get(this.id).subscribe((saleReturn) => { 
            let params ={
              salereturn_id: saleReturn.id
            }
            this.saleReturn = saleReturn;
            this.reason = saleReturn.reason;
            this.totalSale = saleReturn.total;
            this.saleReturnProductService.query(params).subscribe((saleProducts) =>{
                saleProducts.forEach((s)=>{
                    this.checkDiscountForTickeAfterReturn(s);
                    s.barcode = s.saleproduct.barcode;
                    s.name = s.labeledproduct.name;
                    s.imei = (s.labeledproduct.imei1?s.labeledproduct.imei1:'') +" "+ (s.labeledproduct.imei2?s.labeledproduct.imei2:'');
                    s.description = s.saleproduct.description;
                    s.sale_price = s.saleproduct.sale_price;
                    s.discount = s.saleproduct.discount;
                    s.serial_number = s.labeledproduct.serial_number;
                });
                this.addressTicket = this.saleReturn.shop?this.saleReturn.shop.address:"";
                this.createdTicket = this.saleReturn.shop?this.saleReturn.createdBy.name:"";
                this.saleProducts = saleProducts;
            }); 
        });
    }


    calculateTotal(){
        this.totalSale = 0;
        this.saleProducts.forEach((saleProduct) =>{
            if (saleProduct.return){
                this.totalSale += this.roundValue((saleProduct.total))*-1;
            }
        });
    }

    doSaleReturn(){   
        this.addDiscount=false;
        this.addDiscountReturn=false;
        if (_.findIndex(this.saleProducts, (s)=>{ return s.return == true;}) != -1){
            let returnSale = {
                number: 1,
                number_with_serie:'',
                date:new Date(),
                total: this.totalSale,
                reason: this.reason,
                sale_id : this.sale.id,
                method_of_payment: this.method_of_payment == 1? "Efectivo": this.method_of_payment == 2? "Tarjeta":this.method_of_payment == 3? "Bizum":this.method_of_payment == 4? "Transferencia":"Efectivo"
            }
            this.checkCounterNumber(this.shopSerie+"_"+CounterSettings.RETURN_TICKET_COUNTER_LABEL, moment().year()).then((counter:number) =>{
                returnSale.number = counter;
                returnSale.number_with_serie = this.shopSerie+counter;
                this.saleReturnService.create(returnSale).subscribe((returnSale) => {
                    let observableSaleProductsRequests = [];
                    this.saleReturn = returnSale;
                    this.saleProducts.forEach((saleProduct)=>{
                        if (saleProduct.return){
                            saleProduct.quantityForReturn = saleProduct.quantity;
                            let object = {
                                salereturn_id: returnSale.id,
                                saleproduct_id:saleProduct.id,
                                quantity: saleProduct.quantityForReturn?saleProduct.quantityForReturn:1,
                                total:saleProduct.total*-1,
                                labeledproduct_id: saleProduct.labeledproduct.id,
                            }
                            this.checkDiscountForTicket(saleProduct)===true;
                            this.checkDiscountForTickeAfterReturn(saleProduct)===true;
                            observableSaleProductsRequests.push(this.saleReturnProductService.create(object));
                        }
                    });
                    Observable.forkJoin(observableSaleProductsRequests)
                        .subscribe(data => {
                            this.saleReturnService.get(returnSale.id).subscribe((returnSale) => { 
                                this.saleReturn = returnSale;
                                this.addressTicket = returnSale.shop?returnSale.shop.address:"";
                                this.createdTicket = returnSale.shop?returnSale.createdBy.name:"";
                                setTimeout( ()=>{
                                    this.ticketOrInvoice();
                                },0) 
                            });
                        }); 
                });
            });
        }else{
            alert("No has seleccionado ningún producto")
        }
    }

    getSaleProductMarkedToReturn(){
        let productsToReturn = [];
        this.saleProducts.forEach((saleProduct)=>{
            if (saleProduct.return)
                productsToReturn.push(saleProduct)
        });
        return productsToReturn;
    }

    ticketOrInvoice(){
        if (this.sale.invoice_id){
            this.generateInvoice();
            this.router.navigate(['/tpv/']);
        }else{
            this.printTicket();
            this.router.navigate(['/tpv/']);
        }
    }

    ticketOrInvoiceAfterReturn(){
        this.saleProducts.forEach((saleProduct)=>{
            this.checkDiscountForTickeAfterReturn(saleProduct)
        }); 
        if (this.saleReturn.invoice_id){
            this.generateInvoiceAfterReturn();

        }else{
            setTimeout( ()=>{this.printTicketProductReturn();
            },0)
            this.router.navigate(['/tpvreturn/'+this.saleReturn.id]);
           
        }
    }

    checkDiscountForTicket(saleProduct){
        if (saleProduct.discount!==null && saleProduct.discount !== '' && saleProduct.discount !== undefined){
            this.addDiscount=true;
        }
        return true;
    }

    checkDiscountForTickeAfterReturn(salereturnproduct){
        if (salereturnproduct.discount!==null && salereturnproduct.discount !== '' && salereturnproduct.discount !== undefined){
            this.addDiscountReturn=true;
        }
        return true;
    }

    printTicket(){
        document.getElementById("ticket").classList.remove('hide')
        window.print();
        document.getElementById("ticket").classList.add('hide')
        
    }

    printTicketProductReturn(){
        document.getElementById("ticketreturn").classList.remove('hide')
        window.print();
        document.getElementById("ticketreturn").classList.add('hide')    
    }

    checkCounterNumber(counterName, year){
        return new Promise((resolve, reject) => {
            let params = {
                where: {
                    name:counterName, 
                    year: year
                }
            }
            this.counterService.query(params).subscribe((result) => {
                result = result[0];
                if (result === undefined){
                    this.counterService.create({name:counterName,year: year,counter:1}).subscribe(() => {
                        resolve(1)
                    });
                }else{
                    this.counterService.update({id:result.id,counter:result.counter + 1}).subscribe(() => {
                        resolve(result.counter + 1)
                    });
                }
            });
        });
    }

    findPerson(){
        let nif = this.person.nif;
        this.person = {};
        let params={
          nif: nif
        }
        this.personService.query(params)
        .subscribe((people) => {
            if (people[0] === undefined){
                this.person.nif = nif;
            }else{
                var person = people[0];
                this.person = person;
            }
        });
    }

    roundValue(value){
        return Math.round(value * 100) / 100;
    }


    loadFile(url,callback){
        JSZipUtils.getBinaryContent(url,callback);
    }

    generateInvoice(){
        if (this.saleReturn.invoice_id){
            this.invoiceService.get(this.saleReturn.invoice_id).subscribe((invoice)=>{
                this.generatePDFRectificativo(invoice);
                //this.download(invoice);
                this.router.navigate(['/tpvreturn/'+this.saleReturn.id]);
            });
        }else{
            this.invoiceService.get(this.sale.invoice_id).subscribe((saleInvoice)=>{
                this.checkCounterNumber(this.checkSerie(this.saleReturn.shop.id)+"_"+CounterSettings.RETURN_INVOICE_COUNTER_LABEL, moment().year()).then((counter:number) =>{
                    let invoice = {
                        number: counter,
                        serie: this.checkSerie(this.saleReturn.shop.id)+'FR',
                        date: new Date(),
                        customer_name: saleInvoice.customer_name,  
                        customer_nif: saleInvoice.customer_nif,
                        customer_address: saleInvoice.customer_address,
                        customer_cp: saleInvoice. customer_cp,
                        customer_state: saleInvoice.customer_state,
                        customer_phone1: saleInvoice.customer_phone1,
                        customer_phone2: saleInvoice.customer_phone2,
                        tax: 0,
                        tax_amount: 0,
                        total_amount: this.totalSale != undefined? this.totalSale:'',
                    }
                    this.invoiceService.create(invoice).subscribe((invoice)=>{
                        this.saleReturnService.update({id:this.saleReturn.id, invoice_id: invoice.id}).subscribe(()=>{
                            this.generatePDFRectificativo(invoice);
                            //this.download(invoice)
                            this.router.navigate(['/tpvreturn/'+this.saleReturn.id]);
                        });
                    });
                });
            });
        }
    }
    
    generateInvoiceAfterReturn(){
        if (this.saleReturn.invoice_id){
            this.invoiceService.get(this.saleReturn.invoice_id).subscribe((invoice)=>{
                //this.downloadAfterReturn(invoice);
                this.generatePDFRectificativoAfterReturn(invoice);
                this.router.navigate(['/tpvreturn/'+this.saleReturn.id]);
            });
        }else{
            this.invoiceService.get(this.sale.invoice_id).subscribe((saleInvoice)=>{
                this.checkCounterNumber(this.checkSerie(this.saleReturn.shop.id)+"_"+CounterSettings.RETURN_INVOICE_COUNTER_LABEL, moment().year()).then((counter:number) =>{
                    let invoice = {
                        number: counter,
                        serie: this.checkSerie(this.saleReturn.shop.id)+'FR',
                        date: new Date(),
                        customer_name: saleInvoice.customer_name,  
                        customer_nif: saleInvoice.customer_nif,
                        customer_address: saleInvoice.customer_address,
                        customer_cp: saleInvoice. customer_cp,
                        customer_state: saleInvoice.customer_state,
                        customer_phone1: saleInvoice.customer_phone1,
                        customer_phone2: saleInvoice.customer_phone2,
                        tax: 0,
                        tax_amount: 0,
                        total_amount: this.totalSale != undefined? this.totalSale:'',
                    }
                    this.invoiceService.create(invoice).subscribe((invoice)=>{
                        this.saleReturnService.update({id:this.saleReturn.id, invoice_id: invoice.id}).subscribe(()=>{
                            //this.downloadAfterReturn(invoice)
                            this.generatePDFRectificativoAfterReturn(invoice)
                            this.router.navigate(['/tpvreturn/'+this.saleReturn.id]);
                        });
                    });
                });
            });
        }
    }

    downloadAfterReturn(invoice){ 
        var opts = {
            centered : false,
            getImage: function(image){
                return image;
            },
            getSize: function(img,tagValue, tagName) {
                if (tagName == 'imageCB'){
                    return [100,33];}
                if (tagName == 'barcode'){
                    return [100,33]}
                else{
                    return [300,204];
                }
            }
        }
        var imageModule=new ImageModule(opts);
        var _this = this;
    
        this.loadFile("assets/tpv_template-rectificativa.docx",function(error,content){
        if (error) { 
            throw error 
        };
        var zip = new JSZip(content);
        var doc=new Docxtemplater()
                .attachModule(imageModule)
                .loadZip(zip)
        var tpvs = [];
        _this.saleProducts.forEach(function (product){
            tpvs.push(product)
        })
        
        let user = JSON.parse(localStorage.getItem('user'))
        doc.setData({
            tpvs:tpvs,
            date:moment(invoice.date).format("DD-MM-YYYY"),
            num:invoice.number,
            serie:invoice.serie,
            name:invoice.customer_name,
            NIF:invoice.customer_nif,
            address:invoice.customer_address,
            cp:invoice.customer_cp,
            state:invoice.customer_state,
            phone1:invoice.customer_phone1 ,
            phone2:invoice.customer_phone2 ,
            total:invoice.total_amount,
            tax:invoice.tax,
            tax_amount:invoice.tax_amount,
            user:user.username
        });
        try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
        }
        catch (error) {
            var e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties,
            }
            console.log(JSON.stringify({error: e}));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }
        var out=doc.getZip().generate({
            type:"blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            
        }) //Output the document using Data-URI
        //saveAs(out,"output.docx")
        FileSaver.saveAs(out, 'facturarectificativa.docx');  
        });
    }
    generatePDFRectificativoAfterReturn(invoice){ 
        invoice.phone = invoice.customer_phone1 + ', ' + invoice.customer_phone2;
        invoice.number_pdf = invoice.serie + invoice.number;
        invoice.totalPDF = "IMPORTE TOTAL: " + invoice.total_amount +'€';
        var tpvs = [];
        this.saleProducts.forEach(function (product){
            tpvs.push(product)
        })
        const pdf = new PdfMakeWrapper();     
        new Img('https://app.masconberto.com/assets/img/logomasconberto.png').build().then(img => {
        pdf.add(img);
        pdf.add(new Table([
            [ 'ALBERTO H. RODRIGUEZ DELGADO',invoice.customer_name],
            [ '43.796.214-M',invoice.customer_nif],
            [ 'CL SAN FRANCISCO JAVIER 24',invoice.customer_address],
            [ '38001 STA CRUZ DE TENERIFE',invoice.customer_cp ],
            [ 'Tel. 822 04 16 50 - 657 06 11 00',invoice.phone],
            [ 'tienda@masconberto.com','']]).fontSize(10).widths(['65%', '35%']).margin([5,10,0,10]).layout('noBorders').end)
        pdf.add(new Txt('FACTURA RECTIFICATIVA').bold().fontSize(25).margin([5,10,0,10]).end)
        pdf.add(new Table([
            [(new Txt('Factura Nº:').end),(new Txt('Fecha:').end)]]).margin([5,0,0,0]).layout('noBorders').widths(['35%', '35%']).end)
        pdf.add(new Table([
            [(new Txt(invoice.number_pdf).end),(new Txt(moment(invoice.date).format("DD-MM-YYYY")).end)]]).layout('noBorders').widths(['35%', '35%']).margin([5,0,0,5]).end)
        pdf.add(new Table([[
            new Txt('Código').bold().alignment('center').end,
            new Txt('Descripción').bold().end,
            new Txt('Cantidad').bold().end,
            new Txt('Precio Ud.').bold().end,
            new Txt('Dto.').bold().end,
            new Txt('Total').bold().end]]).fontSize(10).alignment('center').widths(['15%', '40%','11%','15%','10%','9%']).margin([0,10,0,0]).end)
        for(let i=0; i<tpvs.length;i++){ 
            tpvs[i].descriptionPDF = tpvs[i].name + tpvs[i].imei;
            tpvs[i].discount =  tpvs[i].discount != undefined? tpvs[i].discount:'';
            pdf.add(
                new Table([[tpvs[i].barcode,new Txt(tpvs[i].descriptionPDF).alignment('left').fontSize(9).end,tpvs[i].quantity,tpvs[i].sale_price,tpvs[i].discount,tpvs[i].total],
                ]).widths(['15%', '40%','11%','15%','10%','9%']).fontSize(9).alignment('center').end);     
        }                       
        pdf.add(new Table([
            ['',invoice.totalPDF]]).widths(['50%','50%']).fontSize(15).margin([0,10,0,0]).layout('noBorders').alignment('right').bold().end)     
        pdf.footer(new Txt ('PARA TRANSFERENCIAS: BBVA : ES68-0182-6601-61-0201582575').bold().fontSize(15).alignment('center').end);
        pdf.create().open();            
        });  
    }

    generatePDFRectificativo(invoice) { 
        invoice.phone = invoice.customer_phone1 + ', ' + invoice.customer_phone2;
        invoice.number_pdf = invoice.serie + invoice.number;
        invoice.totalPDF = "IMPORTE TOTAL: " + invoice.total_amount +'€';
        var tpvs = [];
        this.saleProducts.forEach((saleProduct)=>{
            if (saleProduct.return)
            tpvs.push(saleProduct)
        });
        const pdf = new PdfMakeWrapper();     
        new Img('https://app.masconberto.com/assets/img/logomasconberto.png').build().then(img => {
        pdf.add(img);
        pdf.add(new Table([
            [ 'ALBERTO H. RODRIGUEZ DELGADO',invoice.customer_name],
            [ '43.796.214-M',invoice.customer_nif],
            [ 'CL SAN FRANCISCO JAVIER 24',invoice.customer_address],
            [ '38001 STA CRUZ DE TENERIFE',invoice.customer_cp],
            [ 'Tel. 822 04 16 50 - 657 06 11 00',invoice.phone],
            [ 'tienda@masconberto.com','']]).fontSize(10).widths(['65%', '35%']).margin([5,10,0,10]).layout('noBorders').end)
        pdf.add(new Txt('FACTURA RECTIFICATIVA').bold().fontSize(25).margin([5,10,0,10]).end)
        pdf.add(new Table([
            [(new Txt('Factura Nº:').end),(new Txt('Fecha:').end)]]).margin([5,0,0,0]).layout('noBorders').widths(['35%', '35%']).end)
        pdf.add(new Table([
            [(new Txt(invoice.number_pdf).end),(new Txt(moment(invoice.date).format("DD-MM-YYYY")).end)]]).layout('noBorders').widths(['35%', '35%']).margin([5,0,0,5]).end)
        pdf.add(new Table([[
            new Txt('Código').bold().alignment('center').end,
            new Txt('Descripción').bold().end,
            new Txt('Cantidad').bold().end,
            new Txt('Precio Ud.').bold().end,
            new Txt('Dto.').bold().end,
            new Txt('Total').bold().end]]).fontSize(10).alignment('center').widths(['15%', '40%','11%','15%','10%','9%']).margin([0,10,0,0]).end)
        for(let i=0; i<tpvs.length;i++){ 
            tpvs[i].descriptionPDF = tpvs[i].name + tpvs[i].imei;
            tpvs[i].discount =  tpvs[i].discount != undefined? tpvs[i].discount:'';
            pdf.add(
                new Table([[tpvs[i].barcode,new Txt(tpvs[i].descriptionPDF).alignment('left').fontSize(9).end,tpvs[i].quantity,tpvs[i].sale_price,tpvs[i].discount,tpvs[i].total],
            ]).widths(['15%', '40%','11%','15%','10%','9%']).fontSize(9).alignment('center').end);     
        }                       
        pdf.add(new Table([
            ['',invoice.totalPDF]]).widths(['50%','50%']).fontSize(15).margin([0,10,0,0]).layout('noBorders').alignment('right').bold().end)     
        pdf.footer(new Txt ('PARA TRANSFERENCIAS: BBVA : ES68-0182-6601-61-0201582575').bold().fontSize(15).alignment('center').end);
        pdf.create().open();            
        });  
    }  
    
    download(invoice){ 
        var opts = {
            centered : false,
            getImage: function(image){
                return image;
            },
            getSize: function(img,tagValue, tagName) {
                if (tagName == 'imageCB'){
                    return [100,33];}
                if (tagName == 'barcode'){
                    return [100,33]}
                else{
                    return [300,204];
                }
            }
        }
        var imageModule=new ImageModule(opts);
        var _this = this;
    
        this.loadFile("assets/tpv_template-rectificativa.docx",function(error,content){
        if (error) { 
            throw error 
        };
        var zip = new JSZip(content);
        var doc=new Docxtemplater()
                .attachModule(imageModule)
                .loadZip(zip)
        var tpvs = [];
        _this.saleProducts.forEach((saleProduct)=>{
            if (saleProduct.return)
            tpvs.push(saleProduct)
        });

        doc.setData({
            tpvs:tpvs,
            date:moment(invoice.date).format("DD-MM-YYYY"),
            num:invoice.number,
            serie:invoice.serie,
            name:invoice.customer_name,
            NIF:invoice.customer_nif,
            address:invoice.customer_address,
            cp:invoice.customer_cp,
            state:invoice.customer_state,
            phone1:invoice.customer_phone1 ,
            phone2:invoice.customer_phone2 ,
            total:invoice.total_amount,
            tax:invoice.tax,
            tax_amount:invoice.tax_amount,
        });
        try {
            // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
            doc.render()
        }
        catch (error) {
            var e = {
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties,
            }
            console.log(JSON.stringify({error: e}));
            // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
            throw error;
        }
        var out=doc.getZip().generate({
            type:"blob",
            mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            
        }) //Output the document using Data-URI
        //saveAs(out,"output.docx")
        FileSaver.saveAs(out, 'facturarectificativa.docx');  
        }); 
    }
    
}


// WEBPACK FOOTER //
// ./src/app/tpv/components/tpv-return/tpv-return.component.ts